import { TemplateElement, defineElement, html } from '@webtides/element-js';
import style from './tab-select.css';
import { TabSelectEvent } from '../../events/tab-select-event.js';

/**
 * @typedef {Object} TabOption
 * @property {string} value - The tab panel name
 * @property {string} label - The display label
 */

/**
 * @property {TabOption[]} options - Array of tab options
 * @property {string} selected - Currently selected tab value
 * @property {TabRegisterStore} tabRegisterStore
 */
export default class TabSelect extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            options: [],
            selected: '',
        };
    }

    injectProperties() {
        return {
            /** @type {TabRegisterStore} */
            tabRegisterStore: (tabRegisterStore) => {
                tabRegisterStore.register('select', this);
            },
        };
    }

    events() {
        return {
            '[ref=select]': {
                change: (event) => {
                    const value = event.target.value;
                    this.selected = value;
                    const label = this.options.find((option) => option.value === value)?.label;
                    this.dispatchEvent(new TabSelectEvent(value, label));
                },
            },
        };
    }

    template() {
        return html`
            <select ref="select" class="custom-select">
                ${this.options.map(
                    (option) => html`
                        <option value="${option.value}" ?selected="${option.value === this.selected}">
                            ${option.label}
                        </option>
                    `,
                )}
            </select>
        `;
    }
}

defineElement('mb-tab-select', TabSelect);
